import React, { useContext, useState, useEffect } from "react";
import GeneratePdf from "./GeneratePdf";
import { PDFViewer } from "@react-pdf/renderer";
import { GlobalContext } from "../context/GlobalContext";
import axios from "axios";
import { useParams } from "react-router-dom";

const ViewerPdf = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [imgArr, setImgArr] = useState([]);
  const [img, setImg] = useState();
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { setFetchStatus, fetchStatus } = contextState;
  const { handleEditProduct } = contextFunctions;

  const arrDefault = [
    "_id",
    "nama_produk",
    "jenis_produk",
    "dimensi",
    "bahan",
    "fitur",
    "daya",
    "img",
    "imgPublicID",
    "__v",
    "createdAt",
    "updatedAt",
    "",
  ];

  const dataKeys = Object.keys(filtered);
  const nonIntersectingKeys = dataKeys.filter(
    (key) => !arrDefault.includes(key)
  );

  const filteredData = nonIntersectingKeys.reduce((acc, key) => {
    acc[key] = filtered[key];
    return acc;
  }, {});

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://productspec.cyclic.app/product/${id}`)
      .then((response) => {
        const res = response.data;
        setFiltered(res);
        setImgArr(res.img);
        setImg(res.img[0]);
        setFetchStatus(false);
        setLoading(false);
      });
  }, []);
  if (loading) {
    return <p className="loading"></p>;
  }
  return (
    <div className="page-add ">
      <PDFViewer className="viewer">
        <GeneratePdf data={filtered} img={imgArr} filteredData={filteredData} />
      </PDFViewer>
    </div>
  );
};

export default ViewerPdf;
